// 업데이트 소식 팝업 — 쓰던 화면을 떠나지 않고 "뭐가 바뀌었나"를 확인하는 창.
//
// **왜 화면(페이지)이 아니라 창인가.** 이 알림은 사람이 한창 일하는 도중에 뜬다. 거기서 다른
// 화면으로 데려가면 하던 작업이 끊긴다 — 그래서 그 자리에 창으로 띄우고, 더 보고 싶은 사람만
// 아래 「지난 소식 전체 보기」로 목록 화면에 간다.
//
// **왜 헤더 버튼이 아니라 레이아웃에 붙어 있나.** 창을 여는 상태는 주소(`?modal=whats-new`)가
// 쥐고 있는데, 정작 창을 그리는 코드가 헤더 버튼 안에 들어 있었다. 그래서 2026-08-12 에 버튼을
// 머리말에서 떼어내자 **알림의 「확인하기」를 눌러도 주소만 바뀌고 아무것도 안 뜨는 상태**가 됐다.
// 창은 부르는 자리(버튼·알림)와 떨어져 항상 화면에 살아 있어야 한다.

import { Link } from "react-router";
import { Modal } from "../ui/modal";
import { useModal } from "../../hooks/useModal";
import { useWhatsNew } from "../../hooks/useWhatsNew";
import WhatsNewFeed from "./WhatsNewFeed";

/** 창에서는 최근 것만 보여준다 — 더 거슬러 올라가는 건 목록 화면의 몫이다. */
const RECENT_COUNT = 5;

export default function WhatsNewModal() {
  const { isOpen, closeModal } = useModal("whats-new");
  const { items, loading } = useWhatsNew();

  if (!isOpen) return null;

  return (
    <Modal isOpen onClose={closeModal} className="m-4 max-w-2xl">
      <div className="flex max-h-[85vh] flex-col">
        <div className="border-b border-gray-100 px-6 pb-4 pt-6 dark:border-gray-800">
          <h2 className="text-lg font-bold text-gray-800 dark:text-white/90">업데이트 소식</h2>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            최근에 바뀐 것들입니다. 그림은 왼쪽이 예전, 오른쪽이 지금 화면이에요.
          </p>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto bg-gray-50 px-6 py-5 dark:bg-gray-950">
          <WhatsNewFeed items={items.slice(0, RECENT_COUNT)} loading={loading} />
        </div>
        <div className="border-t border-gray-100 px-6 py-3 text-center dark:border-gray-800">
          <Link
            to="/updates"
            onClick={closeModal}
            className="text-sm font-semibold text-brand-600 transition hover:text-brand-700 dark:text-brand-400"
          >
            지난 소식 전체 보기 →
          </Link>
        </div>
      </div>
    </Modal>
  );
}
